// Puantaj günlük durumu → çeviri anahtarı. TEK harita: Puantaj takvimi (PuantajPage), Puantaj listesi,
// PDKS raporları, Eksik Kayıtlar ve Fazla Mesai Onayları bu haritadan okur — yeni bir durum (ör. AKM
// POC'nin "partialLeave"i) bir yerde unutulup hücrede ham anahtar olarak görünmesin. Renkler
// utils/timesheetStatusColors.js'te, aynı anahtarlarla.
//
// 'overtime' motor tarafından artık ÜRETİLMİYOR (Plan 2) — eski satırların doğru render'ı için etiket
// haritada bilinçli olarak KALIYOR.
const TIMESHEET_STATUS_LABEL_KEYS = {
  normal: 'timesheet.statusNormal',
  absent: 'timesheet.statusAbsent',
  leave: 'timesheet.statusLeave',
  // AKM POC §5.1 — gün kısmen izinle kaplı (saatlik / yarım gün izin + kalan sürede çalışma).
  partialLeave: 'timesheet.statusPartialLeave',
  holiday: 'timesheet.statusHoliday',
  halfDay: 'timesheet.statusHalfDay',
  missingExit: 'timesheet.statusMissingExit',
  overtime: 'timesheet.statusOvertime',
  dayOff: 'timesheet.statusDayOff',
  workedOnDayOff: 'timesheet.statusWorkedOnDayOff',
};

// Sunucudan gelen durumu haritadaki ANAHTARA çevirir (büyük/küçük harf duyarsız): "partialLeave",
// "PartialLeave", "partialleave" → "partialLeave". Bilinmeyen durum olduğu gibi döner. Kişisel puantaj
// ekranları eskiden durumu küçük harfe çevirip renk arıyordu; camelCase durumlar (partialLeave,
// missingExit, dayOff…) renksiz kalıyordu.
export const canonicalTimesheetStatus = (status) => {
  if (!status) return status;
  if (TIMESHEET_STATUS_LABEL_KEYS[status]) return status;
  const lower = String(status).toLowerCase();
  return Object.keys(TIMESHEET_STATUS_LABEL_KEYS).find((k) => k.toLowerCase() === lower) || status;
};

// Çevrilmiş etiket haritası ({ durum: metin }) — liste sütunlarının useMemo'su için.
export const translateTimesheetStatuses = (t) => Object.fromEntries(
  Object.entries(TIMESHEET_STATUS_LABEL_KEYS).map(([status, key]) => [status, t(key)]),
);

export default TIMESHEET_STATUS_LABEL_KEYS;
